import React, { useState, useEffect } from "react";

const SlideForm = ({ slide, onSave, onCancel }) => {
  const [formSlide, setFormSlide] = useState(slide);

  useEffect(() => {
    setFormSlide(slide);
  }, [slide]);

  const handleChange = (e) => {
    setFormSlide({ ...formSlide, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormSlide((prev) => ({ ...prev, image: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  return (
     <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
      <h3>{slide.id ? "Edit Slide" : "Create Slide"}</h3>
      <div className="form-group mb-3">
        <label>Label</label>
        <input
          type="text"
          name="label"
          className="form-control"
          value={formSlide.label}
          onChange={handleChange}
        />
      </div>
      <div className="form-group mb-3">
        <label>Image Upload</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleImageUpload}
        />
        {formSlide.image && (
          <img
            src={formSlide.image}
            alt="preview"
            className="img-thumbnail mt-3"
            style={{ height: "150px", objectFit: "cover" }}
          />
        )}
      </div>
      <div className="d-flex gap-2">
        <button className="btn btn-success" onClick={() => onSave(formSlide)}>
          Save
        </button>
        <button className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
    </div>
    </div>
    </div>
    </section>
  );
};

export default SlideForm;
